<template>
	<div class="container">
		<div class="logo-container mb-3">
			<img alt="logo" class="logo" src="~@img/misc/lineal_logo.png">
			<h6 class="mb-0">Roskildemodellen</h6>
			<h1>Linealen</h1>
		</div>
		<login @cancel="goBack" />		
	</div>
</template>

<script>
	import Login from '@/components/login';

	export default {
		name: 'admin-login',
		components: {
			Login
		},
		methods: {
			goBack() {
				this.$router.push('/');
			}
		}
	}
</script>

<style lang="less" scoped>
	.logo-container {
		display: flex;
		flex-direction: column;
		align-items: center;
	}

	.logo {
		max-width: 350px;
	}
</style>